import sellingProducts11 from '../images/products/11.jpeg'
import sellingProducts21 from '../images/products/21.jpeg'
import sellingProducts31 from '../images/products/31.jpeg'
import sellingProducts41 from '../images/products/41.jpeg'
import sellingProducts51 from '../images/products/51.jpeg'
import sellingProducts61 from '../images/products/61.jpeg'
import sellingProducts71 from '../images/products/71.jpeg'
import sellingProducts81 from '../images/products/81.jpeg'
import sellingProducts12 from '../images/products/12.jpeg'
import sellingProducts22 from '../images/products/22.jpeg'
import sellingProducts32 from '../images/products/32.jpeg'
import sellingProducts42 from '../images/products/42.jpeg'
import sellingProducts52 from '../images/products/52.jpeg'
import sellingProducts62 from '../images/products/62.jpeg'
import sellingProducts72 from '../images/products/72.jpeg'
import sellingProducts82 from '../images/products/82.jpeg'
export const sellingProductsData = [{
    image: sellingProducts11,
    image1: sellingProducts12,

    category: "Ukulele",
    details : "Manaslu Danfe 21″ Soprano Ukulele with FREE Bag",
    price1 : 4500.00,
    price2 : 3000.00,
    sale : true,
    showQuickView: true
    
    
},
{
    image1: sellingProducts22,
    image : sellingProducts21,
    category: "Capo",
    details : "Manaslu Stainless Steel Capo for Guitar",
    price1: 950.00,
    price2: 500.00,
    showQuickView: true,
    sale : true,
    

},
{
    image1: sellingProducts32,
    image : sellingProducts31,
    category: "Acoustic Guitar",
    details : "Manaslu MG5 Semi – Acoustic Guitar With Bag,Capo,String,Belt and Pick",
    price1 : 16000.50,
    price2 : 14800.50,
    sale : true,
    showQuickView: true
    

},
{
    image1: sellingProducts42,
    image : sellingProducts41,
    category: "Audio/Microphone Cable, Microphones",
    details: "Alctron L3018-3m Balance Microphone XLR Cable",
    price1 : 900.00,
    showQuickView: true
    


},
{
    image1: sellingProducts52,
    image : sellingProducts51,
    category : "Capo, Ukulele",
    details : "Ukulele Capo, Normal",
    price1 : 300.00,
    showQuickView: true
    

},
{
    image1: sellingProducts62,
    image : sellingProducts61,
    category : "Acoustic Guitars",
    details : "Yamaha F310 Acoustic Guitar, Natural",
    price1: 16500.00,
    showQuickView: true
    

},
{
    image1: sellingProducts72,
    image : sellingProducts71,
    category : "J Equipments / DJ Controllers",
    details :"Native Instruments Maschine Plus Standalone Production and Performance Instrument",
    price1: 170000.00,
    price2: 145000.00,
    sale:true,
    showQuickView: true
    

},
{
    image1: sellingProducts82,
    image : sellingProducts81,
    category :"Acoustic Guitar Strings",
    details : "DAddario EJ26 Phosphor Bronze Acoustic Guitar Strings, Custom Light",
    price1: 1100.00,
    showQuickView: true
    

}
]
export default sellingProductsData